(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["currency-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', (event) => {
    if (!event.target.matches('.allurez-currency__search')) return;
    const panel = event.target.closest('.allurez-currency__panel');
    const query = event.target.value.trim().toLocaleLowerCase();
    let matches = 0;
    panel.querySelectorAll('.allurez-currency__option').forEach((option) => {
      option.hidden = !option.dataset.search.toLocaleLowerCase().includes(query);
      if (!option.hidden) matches += 1;
    });
    panel.querySelectorAll('.allurez-currency__group').forEach((group) => { group.hidden = Boolean(query); });
    panel.querySelector('.allurez-currency__empty').hidden = matches > 0;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.allurez-currency[open]').forEach((details) => {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.allurez-currency[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('submit', (event) => {
    if (!event.target.closest('.allurez-currency')) return;
    try {
      Object.keys(sessionStorage).filter((key) => key.startsWith('product_cache_')).forEach((key) => sessionStorage.removeItem(key));
    } catch (error) {}
    const returnTo = event.target.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search;
  });
  } catch(e) { console.error(e); }
})();

})();
